import { createPath } from "../helpers"

import { FEEDBACK_URL } from "./constants"
import { TABS } from "./interfaces"

export function matchExactPath(targetPath: string, currentPathname: string) {
    return currentPathname === createPath(targetPath)
}

export function matchSubPath(targetPath: string, currentPathname: string) {
    return currentPathname.startsWith(createPath(targetPath) + "/")
}

export function searchIsActive(tab: TABS, currentPathname: string) {
    switch (tab) {
        case TABS.CALENDAR:
            return matchExactPath("/calendar", currentPathname)
        case TABS.PAYMENTS:
            return matchExactPath("/payouts", currentPathname)
        case TABS.CLIENTS:
            return (
                (matchExactPath("/clients", currentPathname) ||
                    matchSubPath("/clients", currentPathname)) &&
                !matchExactPath(FEEDBACK_URL, currentPathname) &&
                !matchSubPath(FEEDBACK_URL, currentPathname)
            )
        case TABS.CLIENTS_FEEDBACK:
            return (
                matchExactPath(FEEDBACK_URL, currentPathname) ||
                matchSubPath(FEEDBACK_URL, currentPathname)
            )
        default:
            return false
    }
}
